module.exports = __webpack_public_path__ + "img/virginiayarur.9bbf719a.jpg";